// Import the functions you need from the SDKs you need

import {initializeApp} from "firebase/app";
import {getMessaging, getToken} from 'firebase/messaging'
import { getAuth, signOut,  createUserWithEmailAndPassword , signInWithEmailAndPassword, updatePassword, signInAnonymously   } from "firebase/auth";
import { getFirestore,  collection, addDoc, serverTimestamp, doc, setDoc, getDoc,updateDoc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyBIL9BPIYvGCe0LTiWZXK9ud1pqL0-EDvY",
  authDomain: "ezescapetask.firebaseapp.com",
  projectId: "ezescapetask",
  storageBucket: "ezescapetask.appspot.com",
  messagingSenderId: "510732318488",
  appId: "1:510732318488:web:5cd85b4e08dedf3533506d",
  measurementId: "G-YW6H4X5WPL"
};

//local
// const firebaseConfig = {
//   apiKey: "AIzaSyCWQeJkZurDRjVJsyDR55Qw1zkN2p9-Do4",
//   authDomain: "etv3-local.firebaseapp.com",
//   projectId: "etv3-local",
//   storageBucket: "etv3-local.appspot.com",
//   messagingSenderId: "655619661476",
//   appId: "1:655619661476:web:5fb4648c979d7638719031"
// };


// Initialize Firebase
const fbapp = initializeApp(firebaseConfig);
const messaging = getMessaging(fbapp);
export const auth = getAuth(fbapp);

export const db = getFirestore(fbapp);
export const storage = getStorage(fbapp);

const publicKey="BMjQPXe0Plg761Awzi52jVx73Q9HUbXX6dO-VwvkkJavkCfLYAV-AoKGghyy3MyVh_r_BUnCKFReEk82nealNB8"

//local
// const publicKey="BObEVueJ3iXDmo9syAEREWdgBfy0umPg3U9r43Z1dIIZdFALyNvu9YpBIjngQURm3ZQaq548HchO5i80rHamwUk"



export const getMyToken=async(setTokenFound)=>{
  let currentToken='';

  try{

    await getToken(messaging, { vapidKey:publicKey })
    .then((res) => {currentToken= res})
    .catch((err) => console.error(err));

    if(currentToken){
      setTokenFound(true);
      return currentToken
    }else{
      setTokenFound(false);
    }
  }catch(e){
    console.log('an erro while getting firebase token', e)
  }
}

export const OnMessageListener=()=>
  new Promise((resolve)=>{
    messaging.onMessage((payload)=>{
      resolve(payload);
    })
  })

const setFirebaseUserState=async(firebaseUser, email, userId)=>{
  await setDoc(doc(db, "UserState", `${userId}`),{
    email:email,
    status:1,
    uid:firebaseUser.uid,
    authMode:firebaseUser.isAnonymous ? 'anonymous' : 'password',
    updateCategory:false,
    updateComp:false,
    updateTask:false,
    idle:true,
  }, { merge:true });
}

const normalizeFirebasePasswords=(password)=>{
  const values=Array.isArray(password) ? password : [password];
  return values
    .filter((value)=>typeof value==='string' && value.length>0)
    .filter((value, index, arr)=>arr.indexOf(value)===index);
}

export const ensureFirebaseSession=async(email, password, userId)=>{
  const passwords=normalizeFirebasePasswords(password);
  const preferredPassword=passwords[0];

  if(!email || passwords.length===0 || !userId){
    throw new Error('Missing Firebase credentials');
  }

  if(auth.currentUser){
    if(auth.currentUser.email===email){
      await setFirebaseUserState(auth.currentUser, email, userId);
      return auth.currentUser;
    }
    await signOut(auth);
  }

  let lastSignInError=null;
  for(const candidate of passwords){
    try{
      const userCredential=await signInWithEmailAndPassword(auth, email, candidate);
      if(preferredPassword && candidate!==preferredPassword){
        try{
          await updatePassword(userCredential.user, preferredPassword);
        }catch(updateError){
          console.warn('Firebase password normalization failed', updateError.code || updateError.message);
        }
      }
      await setFirebaseUserState(userCredential.user, email, userId);
      return userCredential.user;
    }catch(error){
      lastSignInError=error;
    }
  }

  try{
    const userCredential=await createUserWithEmailAndPassword(auth, email, preferredPassword);
    await setFirebaseUserState(userCredential.user, email, userId);
    return userCredential.user;
  }catch(createError){
    if(createError.code==='auth/email-already-in-use' && lastSignInError){
      try{
        const anonymousCredential=await signInAnonymously(auth);
        await setFirebaseUserState(anonymousCredential.user, email, userId);
        console.warn('Firebase password account is unrecoverable from the client; using authenticated anonymous chat fallback.');
        return anonymousCredential.user;
      }catch(anonymousError){
        anonymousError.originalFirebaseError=lastSignInError;
        throw anonymousError;
      }
    }
    throw createError;
  }
}

 export const RegisterFireBaseUser=async(email, password, userId) =>{
  try{
    return await ensureFirebaseSession(email, password, userId);
  }catch(error){
    console.warn(error.code, error.message)
  }
  }

  export const firebaseUpdatePassword=(email, oldpassword, newPassword)=>{

    signInWithEmailAndPassword(auth, email, oldpassword)
    .then((userCredential) => {
      const user = userCredential.user;
      updatePassword(user, newPassword).then(() => {
        // Update successful.
      }).catch((error) => {
       console.log('an error occured while reseting password');
      });
    })

  }

    
  export const SignInFirebaseUser=async(email, password, userId)=>{
    try{
      return await ensureFirebaseSession(email, password, userId);
    }catch(error){
      console.warn(error.code, error.message)
    }
  }

  export const SignOutFirebaseuser=async(id)=>{
    const uesrOffline = doc(db, "UserState", `${id}`);
        await updateDoc(uesrOffline, {
          status: 0,
          idle:true,
        });
    signOut(auth).then(() => {
      
    }).catch((error) => {
     console.log('an error occurred while signning out', error)
    });
  }

  export const makeTaskSignal=(task, action='updated', changedBy=null)=>{
    if(!task?.id){
      return null;
    }

    return {
      taskId:task.id,
      referenceId:task.referenceId || null,
      companyId:task.companyId || null,
      categoryId:task.categoryId || null,
      action:action,
      changedBy:changedBy,
      nonce:`${Date.now()}-${task.id}-${Math.random().toString(36).slice(2)}`,
    }
  }

  export const requireRefresh=async(id,updateTask, updateCategory,updateComp, taskSignal)=>{
    const uState=doc(db, "UserState", `${id}`);
    const payload={
      updateCategory:updateCategory,
      updateComp:updateComp,
      updateTask:updateTask,
      refreshAt:serverTimestamp(),
      refreshByUid:auth.currentUser?.uid || null,
    };

    if(taskSignal!==undefined){
      payload.taskSignal=taskSignal || null;
    }

    await setDoc(uState, payload, { merge:true });
  }

  export const isIdle=async(id, idle)=>{
    const uState=doc(db, "UserState", `${id}`);
    await updateDoc(uState, {
      idle:idle,
    });
  }


export const notify= async (title, body, onClickLink, receiverId, iconLink, iconType)=>{

  try {
    const {uid}=auth.currentUser;

    const userState = doc(db, "UserState", `${receiverId}`);
    const userSnap = await getDoc(userState);
    var isOnline=false;
    if (userSnap.exists()) {
      const uState=userSnap.data();
      if(uState.status==1){
        isOnline=true;
      }
    } 

    await addDoc(collection(db, "Notifications"), {
      title: title,
      body: body,
      onClickLink: onClickLink,
      receiverId:receiverId,
      uid:uid,
      createdAt:serverTimestamp(),
      delivered:!isOnline,
      read:false,
      iconType:iconType,
      icon:iconLink,
    });


  } catch (e) {
    console.error("Error adding notification: ", e);
  }

}

export const submitMsg=async(roomId,data)=>{
  try{
    if(!auth.currentUser){
      throw new Error('Firebase user is not signed in');
    }
    await addDoc(collection(doc(db, 'Rooms', `${roomId}`), 'messages'),data)

  }
  catch(e){
    console.error("Error sending message: ", e);
  }
}

export const uploadMessageImage=async(roomId, userId, file)=>{
  if(!auth.currentUser){
    throw new Error('Firebase user is not signed in');
  }

  const safeName=file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const imageRef=ref(storage, `Rooms/${roomId}/messages/${userId}/${Date.now()}_${safeName}`);
  const snapshot=await uploadBytes(imageRef, file, {
    contentType:file.type,
    customMetadata:{
      originalName:file.name,
    },
  });

  return getDownloadURL(snapshot.ref);
}

export const ReadMsg=async(roomId, read, docId)=>{
  try{
    const docRef=doc(collection(doc(db, 'Rooms', `${roomId}`), 'messages'), docId)
   
    await updateDoc(docRef, {
      read:read,
    })
  }
  catch(e){
    console.error("Error sending message: ", e);
  }
}

const createUserRoom=async(roomRef, ownerId, userName,photoUrl)=>{
  const userRoomRef=doc(roomRef, "users", `${ownerId}`);
  await setDoc(userRoomRef,{
   activity:0,
   userName:userName,
   photoUrl:photoUrl,
  }, { merge:true })

}

const createMessageRoom=async(roomRef, roomId,uid,ownerId,userName,photoUrl)=>{
  const messageRef=collection(roomRef, "messages");
  await addDoc(messageRef,{
    createdAt:serverTimestamp(),
    msg:"welcome to your company Chat",
    roomId:roomId,
    uid:uid,
    userId:ownerId,
    userName:userName,
    photoUrl:photoUrl,
    msgType:1,
  })

}

export const addRoom=async(roomId, name, ownerId, userName, photoUrl)=>{
  try{
    if(!auth.currentUser){
      throw new Error('Firebase user is not signed in');
    }
    const {uid}=auth.currentUser;
    const roomRef=doc(db, 'Rooms', `${roomId}`)
    await setDoc(roomRef,{
      name:name,
      ownerId:ownerId
    })

    createUserRoom(roomRef, ownerId,userName,photoUrl)
    createMessageRoom(roomRef, roomId,uid,ownerId,userName,photoUrl)
    
  }
  catch(e){
    console.error("Error sending message: ", e);
  }
}

export const addUserToRoom=async(roomId, userId, userName, photoUrl)=>{
  const roomRef=doc(db, 'Rooms', `${roomId}`);
  const userRoomRef=doc(roomRef, "users", `${userId}`);
  const userRoomSnap=await getDoc(userRoomRef);
  const previousActivity=userRoomSnap.exists() && userRoomSnap.data().activity!==undefined ? userRoomSnap.data().activity : -1;
  await setDoc(userRoomRef,{
   activity:previousActivity,
   userName:userName,
   photoUrl:photoUrl,
  }, { merge:true })

}

export const deleteRoom=async(roomId)=>{
  await deleteDoc(doc(db, "Rooms", `${roomId}`));
}

export const updateActivity=async(roomId, userId, activityId)=>{
  const roomRef=doc(db, 'Rooms', `${roomId}`);
  const userRoomRef=doc(roomRef, "users", `${userId}`);
  await updateDoc(userRoomRef,{
   activity:activityId,
  })
}
